// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.calendar-content {
  --background: white;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.day-swiper-container {
  flex: 1;
  width: 100%;
  min-height: 100%;
}
.day-swiper-container swiper-slide {
  height: auto;
  overflow: visible;
  display: block;
  width: 100%;
}
.day-swiper-container ::ng-deep swiper-container {
  height: auto;
  min-height: 100%;
  width: 100%;
}
.day-swiper-container ::ng-deep .swiper-wrapper {
  height: auto;
  min-height: 100%;
}
.day-swiper-container ::ng-deep .swiper-slide {
  height: auto;
  overflow: visible;
}
.day-swiper-container ::ng-deep .swiper {
  height: auto;
  min-height: 100%;
  touch-action: pan-y pinch-zoom;
}

.mini-week-container {
  padding-top: 15px;
  border-bottom: 1px solid #e0e0e0;
  background-color: #f8f9fa;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 100;
}

.day-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px 12px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  min-width: 50px;
}
.day-item:hover {
  background-color: #e9ecef;
}
.day-item.selected {
  background-color: #ed143d;
  color: white;
}

.day-name {
  font-size: 12px;
  font-weight: 500;
  margin-bottom: 2px;
}

.day-number {
  font-size: 16px;
  font-weight: 600;
}

.event-area {
  position: relative;
  overflow-y: visible;
  background-color: white;
  height: 1710px;
  margin: 15px;
  padding-bottom: 20px;
  box-sizing: border-box;
  touch-action: pan-y;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
          user-select: none;
}

.time-slot-line {
  position: absolute;
  left: 0;
  right: 0;
  height: 60px;
  display: flex;
  align-items: flex-start;
  z-index: 1;
  pointer-events: none;
}
.time-slot-line.half-hour-line {
  height: 30px;
}

.time-label {
  font-size: 10px;
  color: #666;
  font-weight: 500;
  text-align: center;
  background-color: #f8f9fa;
  padding: 4px;
  border-radius: 4px;
  margin-right: 5px;
  flex-shrink: 0;
  transform: translateY(-10px);
  pointer-events: none;
}

.time-label-spacer {
  width: 40px;
  flex-shrink: 0;
  margin-right: 5px;
  pointer-events: none;
}

.dotted-line {
  flex: 1;
  height: 0;
  border-top: 1px solid #ccc;
  pointer-events: none;
}
.dotted-line.half-hour-dotted {
  border-top: none;
  height: 1px;
  background-image: repeating-linear-gradient(to right, #ccc 0, #ccc 2px, transparent 2px, transparent 10px);
  background-repeat: repeat-x;
}

.current-time-line {
  position: absolute;
  left: 35px;
  height: 2px;
  right: 0;
  background-color: #ed143d;
  z-index: 10;
  pointer-events: none;
}
.current-time-line::before {
  content: "";
  position: absolute;
  left: 0;
  top: -3px;
  width: 8px;
  height: 8px;
  background-color: #ed143d;
  border-radius: 50%;
}

.current-time-handle {
  position: absolute;
  left: -42px;
  top: -10px;
  background-color: #ed143d;
  color: white;
  padding: 2px 6px;
  border-radius: 8px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
  z-index: 11;
}

.event-block {
  position: absolute;
  background-color: rgba(76, 175, 80, 0.2);
  border-radius: 4px;
  padding: 8px;
  cursor: pointer;
  transition: all 0.2s;
  z-index: 5;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border-left: 4px solid #4CAF50;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  border-right: 1px solid rgba(255, 255, 255, 0.1);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}
.event-block:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}
.event-block:active {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.event-block[style*="z-index: 5"] {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.event-block[style*="z-index: 10"] {
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.15);
  border-radius: 6px;
}
.event-block.unresponded-invitation {
  position: absolute;
  border-left: none;
}
.event-block.unresponded-invitation::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background: var(--border-color, #ed143d);
  background-image: repeating-linear-gradient(45deg, var(--border-color, #ed143d) 0, var(--border-color, #ed143d) 4px, rgba(255, 255, 255, 0.5) 4px, rgba(255, 255, 255, 0.5) 8px);
  border-radius: 4px 0 0 4px;
  z-index: 1;
}

.event-content {
  color: #333;
  font-size: 12px;
  line-height: 1.3;
}

.event-title {
  font-weight: 600;
  margin-bottom: 2px;
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.new-event-icon {
  position: absolute;
  color: orange;
  top: 5px;
  right: 5px;
  z-index: 3;
  font-size: 13px;
}

.event-time {
  font-size: 10px;
  white-space: nowrap;
  margin-bottom: 2px;
}

.event-location {
  font-size: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.no-events {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #666;
  font-style: italic;
  text-align: center;
  font-size: 14px;
  pointer-events: none;
}

.all-day-container {
  position: -webkit-sticky; /* For Safari support */
  position: sticky;
  top: 0;
  display: flex;
  gap: 8px;
  height: 40px;
  margin: 0 5px 0 63px;
  border-bottom: 1px solid #e0e0e0;
  background: white;
  z-index: 20;
}
.all-day-container.shifted-sticky {
  top: 95px;
}

.all-day-event {
  flex: 1;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  border-radius: 4px;
  background: rgba(76, 175, 80, 0.15);
  border-left: 4px solid #4CAF50;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
}
.all-day-event.unresponded-invitation::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background: var(--border-color, #ed143d);
  background-image: repeating-linear-gradient(45deg, var(--border-color, #ed143d) 0, var(--border-color, #ed143d) 4px, rgba(255, 255, 255, 0.5) 4px, rgba(255, 255, 255, 0.5) 8px);
  border-radius: 4px 0 0 4px;
  z-index: 1;
}`, "",{"version":3,"sources":["webpack://./src/app/modals/daily-calendar-modal/daily-calendar-modal.page.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,OAAA;EACA,WAAA;EACA,gBAAA;AACF;AACE;EACE,YAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;AACJ;AAII;EACE,YAAA;EACA,gBAAA;EACA,WAAA;AAFN;AAKI;EACE,YAAA;EACA,gBAAA;AAHN;AAMI;EACE,YAAA;EACA,iBAAA;AAJN;AAQI;EACE,YAAA;EACA,gBAAA;EACA,8BAAA;AANN;;AAWA;EACE,iBAAA;EACA,gCAAA;EACA,yBAAA;EACA,wBAAA;EAAA,gBAAA;EACA,MAAA;EACA,YAAA;AARF;;AAWA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,eAAA;AARF;AAUE;EACE,yBAAA;AARJ;AAWE;EACE,yBAAA;EACA,YAAA;AATJ;;AAaA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;AAVF;;AAaA;EACE,eAAA;EACA,gBAAA;AAVF;;AAaA;EACE,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,YAAA;EACA,oBAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;EACA,yBAAA;UAAA,iBAAA;AAVF;;AAaA;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;EACA,oBAAA;AAVF;AAYE;EACE,YAAA;AAVJ;;AAcA;EACE,eAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,4BAAA;EACA,oBAAA;AAXF;;AAcA;EACE,WAAA;EACA,cAAA;EACA,iBAAA;EACA,oBAAA;AAXF;;AAcA;EACE,OAAA;EACA,SAAA;EACA,0BAAA;EACA,oBAAA;AAXF;AAaE;EACE,gBAAA;EACA,WAAA;EACA,0GAAA;EAOA,2BAAA;AAjBJ;;AAqBA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,QAAA;EACA,yBAAA;EACA,WAAA;EACA,oBAAA;AAlBF;AAoBE;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;AAlBJ;;AAsBA;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;AAnBF;;AAsBA;EACE,kBAAA;EACA,wCAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,oBAAA;EACA,UAAA;EACA,wCAAA;EACA,8BAAA;EACA,8CAAA;EACA,gDAAA;EACA,iDAAA;AAnBF;AAqBE;EACE,2BAAA;EACA,yCAAA;AAnBJ;AAsBE;EACE,wBAAA;EACA,wCAAA;AApBJ;AAwBE;EACE,wCAAA;AAtBJ;AA0BE;EACE,yCAAA;EACA,kBAAA;AAxBJ;AA2BE;EACE,kBAAA;EACA,iBAAA;AAzBJ;AA2BI;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,wCAAA;EACA,gLAAA;EAOA,0BAAA;EACA,UAAA;AA/BN;;AAoCA;EACE,WAAA;EACA,eAAA;EACA,gBAAA;AAjCF;;AAoCA;EACE,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAjCF;;AAoCA;EACE,kBAAA;EACA,aAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;EACA,eAAA;AAjCF;;AAoCA;EACE,eAAA;EACA,mBAAA;EACA,kBAAA;AAjCF;;AAoCA;EACE,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAjCF;;AAqCA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;AAlCF;;AAoCA;EACE,wBAAA,EAAA,uBAAA;EACA,gBAAA;EACA,MAAA;EACA,aAAA;EACA,QAAA;EACA,YAAA;EACA,oBAAA;EACA,gCAAA;EACA,iBAAA;EACA,WAAA;AAjCF;AAkCE;EACE,SAAA;AAhCJ;;AAoCA;EACE,OAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,eAAA;EACA,gBAAA;EAEA,kBAAA;EAEA,mCAAA;EACA,8BAAA;EAEA,gBAAA;EACA,mBAAA;EACA,uBAAA;EAEA,eAAA;AAtCF;AAyCI;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,wCAAA;EACA,gLAAA;EAOA,0BAAA;EACA,UAAA;AA7CN","sourcesContent":[".calendar-content {\n  --background: white;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.day-swiper-container {\n  flex: 1;\n  width: 100%;\n  min-height: 100%;\n  \n  swiper-slide {\n    height: auto;\n    overflow: visible;\n    display: block;\n    width: 100%;\n  }\n  \n  // Configure swiper - let parent handle scrolling\n  ::ng-deep {\n    swiper-container {\n      height: auto;\n      min-height: 100%;\n      width: 100%;\n    }\n    \n    .swiper-wrapper {\n      height: auto;\n      min-height: 100%;\n    }\n    \n    .swiper-slide {\n      height: auto;\n      overflow: visible;\n    }\n    \n    // Allow vertical scrolling to pass through to ion-content\n    .swiper {\n      height: auto;\n      min-height: 100%;\n      touch-action: pan-y pinch-zoom;\n    }\n  }\n}\n\n.mini-week-container {\n  padding-top: 15px;\n  border-bottom: 1px solid #e0e0e0;\n  background-color: #f8f9fa;\n  position: sticky;\n  top: 0;\n  z-index: 100;\n}\n\n.day-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 8px 12px;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s;\n  min-width: 50px;\n\n  &:hover {\n    background-color: #e9ecef;\n  }\n\n  &.selected {\n    background-color: #ed143d;\n    color: white;\n  }\n}\n\n.day-name {\n  font-size: 12px;\n  font-weight: 500;\n  margin-bottom: 2px;\n}\n\n.day-number {\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.event-area {\n  position: relative;\n  overflow-y: visible;\n  background-color: white;\n  height: calc(70px * 24) + 30px; // 25 hours * 70px each (0-23 + 00:00 = 25 hours)\n  margin: 15px;\n  padding-bottom: 20px; // Extra padding at bottom for scrolling\n  box-sizing: border-box;\n  touch-action: pan-y; // Allow vertical scrolling but enable touch events\n  -webkit-touch-callout: none; // Disable iOS callout menu\n  user-select: none; // Prevent text selection during long press\n}\n\n.time-slot-line {\n  position: absolute;\n  left: 0;\n  right: 0;\n  height: 60px;\n  display: flex;\n  align-items: flex-start;\n  z-index: 1;\n  pointer-events: none; // Allow clicks to pass through to event-area\n\n  &.half-hour-line {\n    height: 30px;\n  }\n}\n\n.time-label {\n  font-size: 10px;\n  color: #666;\n  font-weight: 500;\n  text-align: center;\n  background-color: #f8f9fa;\n  padding: 4px;\n  border-radius: 4px;\n  margin-right: 5px;\n  flex-shrink: 0;\n  transform: translateY(-10px);\n  pointer-events: none; // Allow clicks to pass through to event-area\n}\n\n.time-label-spacer {\n  width: 40px; // Match approximate width of time label + margin\n  flex-shrink: 0;\n  margin-right: 5px;\n  pointer-events: none; // Allow clicks to pass through to event-area\n}\n\n.dotted-line {\n  flex: 1;\n  height: 0;\n  border-top: 1px solid #ccc;\n  pointer-events: none; // Allow clicks to pass through to event-area\n  \n  &.half-hour-dotted {\n    border-top: none;\n    height: 1px;\n    background-image: repeating-linear-gradient(\n      to right,\n      #ccc 0,\n      #ccc 2px,\n      transparent 2px,\n      transparent 10px\n    );\n    background-repeat: repeat-x;\n  }\n}\n\n.current-time-line {\n  position: absolute;\n  left: 35px; // Start after time label + margin\n  height: 2px;\n  right: 0;\n  background-color: #ed143d;\n  z-index: 10;\n  pointer-events: none; // Allow clicks to pass through to event-area\n\n  &::before {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: -3px;\n    width: 8px;\n    height: 8px;\n    background-color: #ed143d;\n    border-radius: 50%;\n  }\n}\n\n.current-time-handle {\n  position: absolute;\n  left: -42px; \n  top: -10px;\n  background-color: #ed143d;\n  color: white;\n  padding: 2px 6px;\n  border-radius: 8px;\n  font-size: 11px;\n  font-weight: 600;\n  white-space: nowrap;\n  z-index: 11;\n}\n\n.event-block {\n  position: absolute;\n  background-color: rgba(76, 175, 80, 0.2); // Default semi-transparent background\n  border-radius: 4px;\n  padding: 8px;\n  cursor: pointer;\n  transition: all 0.2s;\n  z-index: 5; // Default z-index, will be overridden by inline style\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  border-left: 4px solid #4CAF50; // Default vivid left border\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n  border-right: 1px solid rgba(255, 255, 255, 0.1);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n\n  &:hover {\n    transform: translateY(-1px);\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n  }\n\n  &:active {\n    transform: translateY(0);\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  }\n\n  // Layer 1: Long events (5+ hours) - Background layer\n  &[style*=\"z-index: 5\"] {\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  }\n\n  // Layer 2: Short events (<5 hours) - Foreground layer\n  &[style*=\"z-index: 10\"] {\n    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.15); // More prominent shadow for foreground events\n    border-radius: 6px; // Slightly more rounded corners for foreground events\n  }\n\n  &.unresponded-invitation {\n    position: absolute;\n    border-left: none; \n    \n    &::before {\n      content: '';\n      position: absolute;\n      left: 0;\n      top: 0;\n      bottom: 0;\n      width: 4px;\n      background: var(--border-color, #ed143d);\n      background-image: repeating-linear-gradient(\n        45deg,\n        var(--border-color, #ed143d) 0,\n        var(--border-color, #ed143d) 4px,\n        rgba(255, 255, 255, 0.5) 4px,\n        rgba(255, 255, 255, 0.5) 8px\n      );\n      border-radius: 4px 0 0 4px;\n      z-index: 1;\n    }\n  }\n}\n\n.event-content {\n  color: #333;\n  font-size: 12px;\n  line-height: 1.3;\n}\n\n.event-title {\n  font-weight: 600;\n  margin-bottom: 2px;\n  font-weight: bold;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.new-event-icon {\n  position: absolute;\n  color: orange;\n  top: 5px;\n  right: 5px;\n  z-index: 3;\n  font-size: 13px;\n}\n\n.event-time {\n  font-size: 10px;\n  white-space: nowrap;\n  margin-bottom: 2px;\n}\n\n.event-location {\n  font-size: 10px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n\n.no-events {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  color: #666;\n  font-style: italic;\n  text-align: center;\n  font-size: 14px;\n  pointer-events: none; // Allow clicks to pass through to event-area\n}\n.all-day-container {\n  position: -webkit-sticky; /* For Safari support */\n  position: sticky;\n  top: 0;\n  display: flex;\n  gap: 8px;\n  height: 40px;\n  margin: 0 5px 0 63px;\n  border-bottom: 1px solid #e0e0e0;\n  background: white;\n  z-index: 20;\n  &.shifted-sticky {\n    top: 95px;\n  }\n}\n\n.all-day-event {\n  flex:1;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  font-size: 12px;\n  font-weight: 600;\n\n  border-radius: 4px;\n\n  background: rgba(76, 175, 80, 0.15);\n  border-left: 4px solid #4CAF50;\n\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n\n  cursor: pointer;\n  &.unresponded-invitation {\n    \n    &::before {\n      content: '';\n      position: absolute;\n      left: 0;\n      top: 0;\n      bottom: 0;\n      width: 4px;\n      background: var(--border-color, #ed143d);\n      background-image: repeating-linear-gradient(\n        45deg,\n        var(--border-color, #ed143d) 0,\n        var(--border-color, #ed143d) 4px,\n        rgba(255, 255, 255, 0.5) 4px,\n        rgba(255, 255, 255, 0.5) 8px\n      );\n      border-radius: 4px 0 0 4px;\n      z-index: 1;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
